import { makeAutoObservable } from 'mobx';
import { token } from '@/infrastructure/container';
import { type IAppBus } from '@/services/AppBus';
import { type SourceKind } from '@/domain/beforered';

export interface Warning {
  source: SourceKind;
  message: string;
  count: number;
}

export class WarningsStore {
  private _warnings: Warning[] = [];

  constructor(bus: IAppBus) {
    makeAutoObservable(this);
    bus.subscribe('VALIDATION_WARNING', this.onWarning);
  }

  get warnings(): readonly Warning[] {
    return this._warnings;
  }

  clear = (): void => {
    this._warnings = [];
  };

  private onWarning = (data: Warning): void => {
    this._warnings = [...this._warnings, data];
  };
}

export const TOKEN_WarningsStore = token<WarningsStore>('WarningsStore');
